import axios from 'axios';
import router from "../router";

export const user = {
  namespaced: true,
  state: () => ({
    //loginStatus為false代表未登入，為true代表已登入
    loginStatus: false,
    //會員資訊
    memberData: null,
    //登入資訊包含token
    loginData: null,
    loginModalVisibility: false,
    // Email 閘門：undefined=尚未檢查、null=通過、'required'/'verify'=未完成
    emailGate: undefined,
  }),
  mutations: {
    changeMemberID(state,status){
      state.memberData.data.identification = status;
    },
    changeMemberEmail(state,status){
      state.memberData.data.email = status;
    },
    changeMemberName(state,status){
      state.memberData.data.full_name = status;
    },
    setMemberData(state, data) {
      state.memberData = data;
    },
    changeLoginStatus(state, status) {
      state.loginStatus = status;
    },
    setLoginData(state, status) {
      state.loginData = status;
    },
    setBindingSucessData(state,status){
      state.memberData.data.platform_status[status] = true;
    },
    changeBindingData(state,status){
      state.memberData.data.platform_status[status] = false;
    },
    updateLoginModalVisibility(state, status) {
      state.loginModalVisibility = status;
    },
    setEmailGate(state, gate) {
      state.emailGate = gate;
    },
  },
  actions: {
    fetchMemberData({ commit, state, dispatch }) {
      const apiUrl = `${process.env.VUE_APP_PATH}/user/get_info`;
      axios.get(apiUrl,{
        headers: {
          'Authorization': `Bearer ${state.loginData.access_token}`,
        }
      }).then(response => { 
        if(response.data.status_code === 'SYSTEM_1000') {
          commit('setMemberData', response.data);
        } else if(response.data.status_code === 'SYSTEM_1004') {
          dispatch('updateLoginStatus', false);
          dispatch('updateLoginData', []);
          dispatch('cleanMemberData');
          router.push('/');
        }
      }).catch(error => {
        console.error(error);
      });
    },
    checkVerifiedMail({ state, commit }) {
      if (!state.loginData?.access_token) {
        commit('setEmailGate', undefined);
        return Promise.resolve(null);
      }
      const apiUrl = `${process.env.VUE_APP_PATH}/user/check-verify-email`;
      return new Promise((resolve, reject) => {
        axios.get(apiUrl, {
          headers: {
            'Authorization': `Bearer ${state.loginData.access_token}`,
          }
        })
        .then(response => {
          if (response.data.status_code === 'SYSTEM_1000') {
            commit('setEmailGate', response.data.email_gate ?? null);
            resolve(response.data); // { verify_email, email_gate }
          } else {
            console.log('error', response.data.status_code);
            resolve(null); 
          }
        })
        .catch(error => {
          console.error(error);
          reject(error); 
        });
      })
    },
    updateLoginStatus({ commit }, status) {
      commit('changeLoginStatus', status);
      if (!status) {
        commit('setEmailGate', undefined);
      }
    },
    updateLoginData({ commit }, status) {
      commit('setLoginData', status);
    },
    cleanMemberData({commit}){
      commit('setMemberData', []);
      commit('setEmailGate', undefined);
    },
    bindSuccessData({commit},status){
      commit('setBindingSucessData',status);
    },
    updateBindingData({commit},status){
      commit('changeBindingData', status);
    },
    updateMemberName({commit},status){
      commit('changeMemberName',status)
    },
    updateMemberEmail({commit},status){
      commit('changeMemberEmail',status)
    },
    updateMemberID({commit},status){
      commit('changeMemberID',status)
    },
  },
  getters: {
    getLoginStatus(state){
      return state.loginStatus;
    },
    getMemberData(state) {
      return state.memberData;
    },
    getLoginData(state){
      return state.loginData;
    },
    getMemberBinding(state){
      return state.memberData.data.platform_status
    },
  },
};